import * as React from 'react';
import { Provider } from 'mobx-react';
import { AnalyticsStore } from './stores';
import { Analytics } from './Analytics';
import { IUser } from '../../interfaces/IUser';

export interface IProps {
  tenant: string;
  token: string;
  environment?: "Development" | "Test" | "Production";
  highlightColor: string;
  user: IUser;
}

export class IAAnalytics extends React.Component<IProps> {

  private analyticsStore: AnalyticsStore;

  constructor(props: IProps) {
    super(props);
    
    this.analyticsStore = new AnalyticsStore();
    this.analyticsStore.tenant = props.tenant;
    this.analyticsStore.token = props.token;
    this.analyticsStore.environment = props.environment;
    this.analyticsStore.highlightColor = props.highlightColor;
    this.analyticsStore.user = props.user;
  }

  public componentWillReceiveProps(props: IProps) {
    this.analyticsStore.tenant = props.tenant;
    this.analyticsStore.token = props.token;
    this.analyticsStore.environment = props.environment;
    this.analyticsStore.highlightColor = props.highlightColor;
    this.analyticsStore.user = props.user;
  }

  render() {
    return (
      <Provider analyticsStore={this.analyticsStore}>
        <Analytics />
      </Provider>
    )
  }
}